Oskari.bundle_manager.registerDynamic('personaldata', function() {return import(/* webpackChunkName: "chunk_personaldata" */ "oskari-loader!./bundle.js");});
